import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { Store } from "@ngrx/store";
import * as fromApp from "../../../../store/app.reducer";
import * as selectors from "../../../../store/app.selectors";
import * as _ from "lodash";
import { AlertController, ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import * as CartActions from "../../../../cart/store/cart.actions";
import { distinctUntilChanged, first } from "rxjs/operators";
import { Subscription } from "rxjs";
import { ProductDetailsComponent } from "src/app/product-details/product-details.component";
import * as selectedProductActions from "../../../store/selectedProduct.actions";
import { ProductValidDeliveryAreasPopupComponent } from "src/app/popups/product-valid-delivery-areas-popup/product-valid-delivery-areas-popup.component";
import { ProductDetailsOperationsService } from "src/app/product-details/product-details-operations.service";
import { QUANTITY_DECIMALS } from "../../../../services/quantity-decimals";
declare let window: any;
@Component({
  selector: "app-bundle-product-item",
  templateUrl: "./bundle-product-item.component.html",
  styleUrls: ["./bundle-product-item.component.scss"],
})
export class BundleProductItemComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() selectedProductId: any;
  @Input() choice: any;
  @Input() option_id: any;
  @Input() bundleProduct: any;
  @Input() groupStoreData: any;
  @Output() optionChanged = new EventEmitter();

  public finalPriceLoading: boolean;
  public showProductItemDetails: boolean = false;
  public orderPickup: any;
  public dineIn: any;
  public deleteAlertConfirm: any;
  public groupApp: any;
  public productPointsSystemException: boolean;
  public productPointSystemWeight: number = 1;
  public store_info: any;
  public selectedProduct: any;
  public selectedDineInTable: any;
  public onlyAvailableForPreorderProductsById: any;
  public image: any = {};
  public selectedAddress: any;
  public option: any;
  public bundleProductChoiceQuantity;
  public bundleOptionsLoading: boolean = false;
  public bundleEditOnImageEnabled: boolean = false;

  private noMaxStep = false;
  private bundleOptionLoadingArray;
  private productValidDeliveryAreasModal;
  private productDetailsModal: any;
  private subscriptions: Subscription[] = [];

  constructor(
    private store: Store<fromApp.AppState>,
    private alertCtrl: AlertController,
    private translateService: TranslateService,
    private productDetailsOperationsService: ProductDetailsOperationsService,
    private modalController: ModalController
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    console.log("bundle product", this.bundleProduct);
    this.initProductImage();
  }

  checkForDepentantOption() {
    if (this.option_id) {
      const option = _.find(this.selectedProduct.options, {
        option_id: this.option_id,
      });
      if (
        option.dependenciesVariable &&
        option.dependenciesVariable.length > 0 &&
        !option.dependentHidden &&
        !option.showDependent
      ) {
        this.deleteBundleProduct(this.bundleProduct);
      }
    }
  }

  ngOnInit() {
    console.log("aksdasd", this.choice);
    this.initProductImage();

    this.subscriptions.push(
      this.store
        .select(
          selectors.getSelectedProductBySelectedProductId(
            this.selectedProductId
          )
        )
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (state && !_.isEqual(this.selectedProduct, state)) {
            this.selectedProduct = _.cloneDeep(state);
            this.option = _.find(this.selectedProduct.options || [], {
              option_id: this.option_id,
            });

            this.checkForDepentantOption();
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("productOptionsValidation")

        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            state.bundleOptionLoadingArray &&
            !_.isEqual(
              this.bundleOptionLoadingArray,
              state.bundleOptionLoadingArray
            )
          ) {
            this.bundleOptionLoadingArray = _.cloneDeep(
              state.bundleOptionLoadingArray
            );

            if (
              this.bundleOptionLoadingArray &&
              this.bundleOptionLoadingArray.length
            ) {
              this.bundleOptionsLoading = true;
            } else {
              if (this.bundleOptionsLoading) {
                setTimeout(() => {
                  this.checkForZeroQuntities();
                }, 0);
                setTimeout(() => {
                  this.bundleOptionsLoading = false;
                }, 600);
              }
            }
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("deliveryMethodAddress")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (state && !_.isEqual(this.orderPickup, state.orderPickup)) {
            this.orderPickup = _.cloneDeep(state.orderPickup);
          }

          if (state && !_.isEqual(this.dineIn, state.dineIn)) {
            this.dineIn = _.cloneDeep(state.dineIn);
          }

          if (
            state &&
            !_.isEqual(this.selectedDineInTable, state.selectedDineInTable)
          ) {
            this.selectedDineInTable = _.cloneDeep(state.selectedDineInTable);
          }

          if (
            state &&
            !_.isEqual(this.selectedAddress, state.selectedAddress)
          ) {
            this.selectedAddress = _.cloneDeep(state.selectedAddress);
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("disableFinalPrice")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            !_.isEqual(this.finalPriceLoading, state.disableFinalPrice)
          ) {
            this.finalPriceLoading = _.cloneDeep(state.disableFinalPrice);
          }
        })
    );

    // if (this.cartProduct) {
    //   this.cartProduct.options.forEach((opt) => {
    //     //console.log(opt);
    //   });
    // }
    // this.subscription2 = this.store
    //   .select("deliveryMethodAddress")
    //   .subscribe((state) => {
    //     if (state && _.isEqual(state.orderPickup, this.orderPickup)) {
    //       this.orderPickup = _.cloneDeep(state.orderPickup);
    //     }
    //   });

    this.subscriptions.push(
      this.store
        .select("cart")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            !_.isEqual(
              this.onlyAvailableForPreorderProductsById,
              state.onlyAvailableForPreorderCartProductsById
            )
          ) {
            this.onlyAvailableForPreorderProductsById = _.cloneDeep(
              state.onlyAvailableForPreorderCartProductsById
            );
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("groupApp")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            state.groupApp &&
            !_.isEqual(state.groupApp, this.groupApp)
          ) {
            this.groupApp = _.cloneDeep(state.groupApp);
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select(selectors.getStoreInfo)
        .pipe(distinctUntilChanged())
        .subscribe((store_info) => {
          if (store_info && !_.isEqual(store_info, this.store_info)) {
            this.store_info = _.cloneDeep(store_info);
          }

          this.bundleEditOnImageEnabled = !!(
            store_info &&
            store_info.design_settings &&
            store_info.design_settings.mobileorder_bundle_edit_on_image
          );
        })
    );

    this.store
      .select("deliveryMethodAddress")
      .pipe(first())
      .subscribe((state) => {
        if (
          this.bundleProduct &&
          this.choice &&
          this.option &&
          this.option.bundle_options &&
          this.option.bundle_options.preselectedQuantityZero &&
          this.option.choices &&
          this.option.choices.length === 1 &&
          this.choice.bundle_options &&
          this.choice.bundle_options.enable_bundle_product_quantity &&
          this.choice.bundle_options.bundleProductQuantityMultiplierFromChoices
        ) {
          this.showProductItemDetails = true;
          const bundleOptions = this.bundleProduct.options || [];
          this.noMaxStep = true;
          this.bundleProduct = this.initializeProductOptionsCheckbox(
            _.cloneDeep(this.bundleProduct)
          );

          this.bundleProduct =
            this.productDetailsOperationsService.productAllOptionsPriceComments(
              _.cloneDeep(this.bundleProduct),
              state.orderPickup,
              state.dineIn,
              false,
              state.selectedDineInTable
            );

          for (const opt of bundleOptions) {
            if (opt.rdc_migrated === true && Array.isArray(opt.choices)) {
              for (const ch of opt.choices) {
                if (
                  ch.productQuantityMultiplier &&
                  ch.productQuantityMultiplier > 1
                ) {
                  this.bundleProduct.quantity_step = _.cloneDeep(
                    ch.productQuantityMultiplier
                  );
                  this.bundleProduct.enable_quantity_step = true;

                  break; // stop at the first match
                }
              }
            }
          }
        }
      })
      .unsubscribe();

    this.bundleProduct = this.checkProductQuantityToChoice(
      _.cloneDeep(this.bundleProduct)
    );

    if (
      this.bundleProduct &&
      this.bundleProduct.quantity !== 0 &&
      this.choice &&
      this.option &&
      this.option.bundle_options &&
      this.option.bundle_options.preselectedQuantityZero &&
      this.option.choices &&
      this.option.choices.length === 1 &&
      this.choice.bundle_options &&
      this.choice.bundle_options.enable_bundle_product_quantity &&
      this.choice.bundle_options.bundleProductQuantityMultiplierFromChoices &&
      (!this.bundleProduct.product_categories_availability_check ||
        !this.bundleProduct.availableTotal)
    ) {
      for (let i = 0; i < this.bundleProduct.quantity; i++) {
        this.productQuantityDecrease();
      }
    }
  }

  checkProductQuantityToChoice(tempProduct) {
    if (
      tempProduct &&
      this.choice &&
      this.option &&
      this.option.bundle_options &&
      this.option.bundle_options.preselectedQuantityZero &&
      this.option.choices &&
      this.option.choices.length === 1 &&
      this.choice.bundle_options &&
      this.choice.bundle_options.enable_bundle_product_quantity &&
      this.choice.bundle_options.bundleProductQuantityMultiplierFromChoices
    ) {
      for (const opt of tempProduct.options || []) {
        if (opt.rdc_migrated === true && Array.isArray(opt.choices)) {
          for (const ch of opt.choices) {
            if (
              ch.productQuantityMultiplier &&
              ch.productQuantityMultiplier > 1
            ) {
              if (tempProduct.quantity > 0) {
                ch.is_preselected = true;
                ch.quantity = parseInt(
                  (
                    parseFloat(tempProduct.quantity.toString()) /
                    parseFloat(ch.productQuantityMultiplier.toString())
                  ).toFixed(0)
                );
                this.bundleProductChoiceQuantity = _.cloneDeep(ch.quantity);

                tempProduct =
                  this.productDetailsOperationsService.productAllOptionsPriceComments(
                    _.cloneDeep(tempProduct),
                    this.orderPickup,
                    this.dineIn,
                    false,
                    this.selectedDineInTable
                  );
              } else {
                ch.is_preselected = false;
                ch.quantity = 1;

                this.bundleProductChoiceQuantity = null;

                tempProduct =
                  this.productDetailsOperationsService.productAllOptionsPriceComments(
                    _.cloneDeep(tempProduct),
                    this.orderPickup,
                    this.dineIn,
                    false,
                    this.selectedDineInTable
                  );
              }

              break; // stop at the first match
            }
          }
        }
      }
    }

    return _.cloneDeep(tempProduct);
  }

  calculateTotalChoiceQuantity(option_id, product) {
    if (!option_id) {
      return;
    }
    var optionIndex = _.findIndex(product.options, {
      option_id: option_id,
    });
    var choicesQuantity = 0;
    _.each(product.options[optionIndex].choices, (choice) => {
      if (
        choice.is_preselected &&
        choice.activeTotal &&
        choice.availableTotal
      ) {
        choicesQuantity = choicesQuantity + choice.quantity;
      }
    });

    product.options[optionIndex].optionData.freeChoices =
      choicesQuantity >= parseInt(product.options[optionIndex].freeChoices)
        ? product.options[optionIndex].freeChoices
        : choicesQuantity;
    product.options[optionIndex].optionData.maxChoices =
      choicesQuantity >= parseInt(product.options[optionIndex].maxChoices)
        ? product.options[optionIndex].maxChoices
        : choicesQuantity;
    product.options[optionIndex].optionData.minChoices =
      choicesQuantity >= parseFloat(product.options[optionIndex].minChoices)
        ? product.options[optionIndex].minChoices
        : choicesQuantity;
  }

  assignFreeChoices(option_id, product) {
    if (!option_id) {
      // There are some options that do not have option_id
      return;
    }
    var optionIndex = _.findIndex(product.options, {
      option_id: option_id,
    });

    var optionsFreeChoices = parseInt(product.options[optionIndex].freeChoices);

    let sortByVariable: any = "price";

    if (
      product &&
      product.options &&
      product.options[optionIndex] &&
      product.options[optionIndex].freeChoices &&
      product.options[optionIndex].freeChoicesBySelectionOrder
    ) {
      sortByVariable = "selected_timestamp";
    }

    if (
      product &&
      product.options &&
      product.options[optionIndex] &&
      product.options[optionIndex].freeChoices &&
      product.options[optionIndex].freeChoicesByPosition
    ) {
      sortByVariable = (choice, index) => index;
    }

    const sortedChoices = _.sortBy(
      product.options[optionIndex].choices,
      (choice, index) => {
        if (sortByVariable === "price") {
          if (this.orderPickup && choice.price_takeaway) {
            sortByVariable = "price_takeway";
            return choice.price_takeaway;
          } else if (this.dineIn && choice.price_dinein) {
            sortByVariable = "price_dinein";
            return choice.price_dinein;
          }
          return choice.price;
        } else if (typeof sortByVariable === "function") {
          return sortByVariable(choice, index);
        } else {
          return choice[sortByVariable];
        }
      }
    );

    console.log("sortedChoices", sortedChoices);

    _.each(sortedChoices, (choice) => {
      if (
        this.dineIn &&
        (!choice.price_dinein || choice.price_dinein === 0) &&
        (!choice.price || choice.price === 0) &&
        product.options[optionIndex].freeChoicesbyPriceSkipZeros
      ) {
        return;
      }
      if (
        this.orderPickup &&
        (!choice.price_takeaway || choice.price_takeaway === 0) &&
        (!choice.price || choice.price === 0) &&
        product.options[optionIndex].freeChoicesbyPriceSkipZeros
      ) {
        return;
      }

      if (
        !this.orderPickup &&
        !this.dineIn &&
        (!choice.price || choice.price === 0) &&
        product.options[optionIndex].freeChoicesbyPriceSkipZeros
      ) {
        return;
      }

      if (
        optionsFreeChoices > 0 &&
        choice.is_preselected &&
        choice.activeTotal &&
        choice.availableTotal
      ) {
        product.options[optionIndex].choices[
          _.findIndex(product.options[optionIndex].choices, {
            choice_id: choice.choice_id,
          })
        ].isFree = true;
        if (choice.quantity > 1) {
          if (optionsFreeChoices - choice.quantity >= 0) {
            product.options[optionIndex].choices[
              _.findIndex(product.options[optionIndex].choices, {
                choice_id: choice.choice_id,
              })
            ].freeQuantity = choice.quantity;
            optionsFreeChoices -= choice.quantity;
          } else {
            product.options[optionIndex].choices[
              _.findIndex(product.options[optionIndex].choices, {
                choice_id: choice.choice_id,
              })
            ].freeQuantity = optionsFreeChoices;
            optionsFreeChoices -= optionsFreeChoices;
          }
        } else {
          product.options[optionIndex].choices[
            _.findIndex(product.options[optionIndex].choices, {
              choice_id: choice.choice_id,
            })
          ].freeQuantity = 1;
          optionsFreeChoices -= 1;
        }
      } else {
        product.options[optionIndex].choices[
          _.findIndex(product.options[optionIndex].choices, {
            choice_id: choice.choice_id,
          })
        ].isFree = false;
        product.options[optionIndex].choices[
          _.findIndex(product.options[optionIndex].choices, {
            choice_id: choice.choice_id,
          })
        ].freeQuantity = 0;
      }
    });

    optionsFreeChoices = null;
  }

  initializeProductOptionsCheckbox(product) {
    _.each(product.options, (option, o, p) => {
      product.options[o].optionData = {
        freeChoices: 0,
        minChoices: 0,
        maxChoices: 0,
      };
      var choiceWithStepFound = _.find(option.choices, (choice) => {
        return (
          choice.quantityInChoicesStep && choice.quantityInChoicesStep !== 1
        );
      });

      //console.log("initializePrdOptionsCheckbox", choiceWithStepFound);

      if (
        option.is_require &&
        !_.has(option, "minChoices") &&
        !choiceWithStepFound
      ) {
        product.options[o].minChoices = "1";
      } else if (
        option.is_require &&
        !_.has(option, "minChoices") &&
        choiceWithStepFound
      ) {
        product.options[o].minChoices =
          choiceWithStepFound.quantityInChoicesStep;
      }

      _.each(option.choices, (choice, c, l) => {
        if (
          !(
            choice.is_preselected &&
            choice.activeTotal &&
            choice.availableTotal
          )
        ) {
          product.options[o].choices[c].is_preselected = false;
        }

        if (!choice.quantity) {
          if (!choice.quantityInChoicesStep) {
            product.options[o].choices[c].quantity = 1;
          } else {
            product.options[o].choices[c].quantity = _.cloneDeep(
              choice.quantityInChoicesStep
            );
          }
        }

        if (choice.quantity && choice.quantityInChoicesStep) {
          product.options[o].choices[c].quantity = _.cloneDeep(
            choice.quantityInChoicesStep
          );
        }

        if (!choice.freeQuantity) {
          product.options[o].choices[c].freeQuantity = 0;
        }
      });

      this.assignFreeChoices(option.option_id, product);
      this.calculateTotalChoiceQuantity(option.option_id, product);
    });

    return product;
  }

  checkForZeroQuntities() {
    if (
      this.bundleProduct &&
      this.bundleProduct.quantity === 0 &&
      !this.bundleProduct.disable_qty &&
      this.choice?.bundle_options?.enable_bundle_product_quantity
    ) {
      console.log("hererer!");

      this.bundleProductChanged(_.cloneDeep(this.bundleProduct));
    }
  }

  initProductImage() {
    this.store
      .select("groupApp")
      .pipe(first())
      .subscribe((state) => {
        if (
          this.bundleProduct &&
          this.bundleProduct.image &&
          this.bundleProduct.image.true &&
          this.bundleProduct.image.true["4x3"] &&
          this.bundleProduct.image.true["4x3"].path &&
          state.groupApp &&
          (!state.groupApp.disableCatalogPhoto ||
            state.groupApp.disableCatalogPhoto)
        ) {
          this.image.path =
            "https://images.deliverymanager.gr/" +
            this.choice.bundled_product.image.true["4x3"].path +
            (state.webp
              ? ".webp"
              : this.choice.bundled_product.image.true["4x3"].type || ".jpg");
        }
      })
      .unsubscribe();

    console.log("imagegegegeg", this.image);
  }

  calculateProductPointSystemAttributes() {}

  // calculatePrice() {
  //   let price = parseFloat(this.cartProduct.price);
  //   let quantity = parseFloat(this.cartProduct.quantity);
  //   return (price * quantity).toFixed(2) + "€";
  // }

  presentAlertConfirm(bundleProduct) {
    if (!this.deleteAlertConfirm) {
      this.deleteAlertConfirm = true;
      this.showAlertConfirm(bundleProduct);
    }
  }

  showProductValidDeliveryAreasInfoModal() {
    if (!this.productValidDeliveryAreasModal) {
      this.presentProductValidDeliveryAreasModal();
    }
  }

  async presentProductValidDeliveryAreasModal() {
    this.productValidDeliveryAreasModal = await this.modalController.create({
      component: ProductValidDeliveryAreasPopupComponent,
      cssClass: "productValidDeliveryAreasPopup",
      animated: true,
      componentProps: {
        notValidAddress: this.selectedAddress,
        cartProduct: this.selectedProduct,
      },
      backdropDismiss: false,
    });

    await this.productValidDeliveryAreasModal.present();
    this.productValidDeliveryAreasModal.onDidDismiss().then(() => {
      this.productValidDeliveryAreasModal = null;
    });
  }

  async showAlertConfirm(bundleProduct) {
    this.deleteAlertConfirm = await this.alertCtrl.create({
      cssClass: "my-custom-class",
      header: this.translateService.instant(
        "product-details.bundle-option.bundle-product-item.delete"
      ),
      message: this.translateService.instant(
        "product-details.bundle-option.bundle-product-item.do-you-want-to-delete-product"
      ),
      buttons: [
        {
          text: this.translateService.instant(
            "product-details.bundle-option.bundle-product-item.cancel"
          ),
          role: "cancel",
          cssClass: "secondary",
        },
        {
          text: this.translateService.instant(
            "product-details.bundle-option.bundle-product-item.delete"
          ),
          handler: () => {
            this.deleteBundleProduct(bundleProduct);
          },
        },
      ],
    });

    await this.deleteAlertConfirm.present();
    this.deleteAlertConfirm.onDidDismiss().then(() => {
      this.deleteAlertConfirm = false;
    });
  }

  async productQuantityDecrease() {
    let tempProduct = _.cloneDeep(this.bundleProduct);

    if (
      this.bundleProduct &&
      this.bundleProduct.enable_quantity_step &&
      this.bundleProduct.quantity_step &&
      this.bundleProduct.quantity === this.bundleProduct.quantity_step
    ) {
      tempProduct.quantity = 0;
      tempProduct = this.checkProductQuantityToChoice(_.cloneDeep(tempProduct));
      this.bundleProductChanged(_.cloneDeep(tempProduct));
    } else if (
      this.bundleProduct &&
      this.bundleProduct.quantity > 0 &&
      this.bundleProduct.enable_quantity_step &&
      this.bundleProduct.quantity_step
    ) {
      if (tempProduct.min_quantity) {
        if (
          parseFloat(
            parseFloat(
              _.cloneDeep(
                tempProduct.quantity - tempProduct.quantity_step
              ).toString()
            ).toFixed(QUANTITY_DECIMALS)
          ) >= tempProduct.min_quantity
        ) {
          tempProduct.quantity = parseFloat(
            parseFloat(
              _.cloneDeep(
                tempProduct.quantity - tempProduct.quantity_step
              ).toString()
            ).toFixed(QUANTITY_DECIMALS)
          );
          tempProduct = this.checkProductQuantityToChoice(
            _.cloneDeep(tempProduct)
          );
          this.bundleProductChanged(_.cloneDeep(tempProduct));
        }
      } else {
        if (tempProduct.quantity - tempProduct.quantity_step > 0) {
          tempProduct.quantity = parseFloat(
            parseFloat(
              _.cloneDeep(
                tempProduct.quantity - tempProduct.quantity_step
              ).toString()
            ).toFixed(QUANTITY_DECIMALS)
          );
          tempProduct = this.checkProductQuantityToChoice(
            _.cloneDeep(tempProduct)
          );
          this.bundleProductChanged(_.cloneDeep(tempProduct));
        }
      }

      //console.log(tempProduct.quantity);
      //console.log("set selectedProduct");
    } else if (
      this.bundleProduct &&
      this.bundleProduct.quantity > 1 &&
      (!this.bundleProduct.enable_quantity_step ||
        !this.bundleProduct.quantity_step)
    ) {
      tempProduct.quantity--;
      tempProduct = this.checkProductQuantityToChoice(_.cloneDeep(tempProduct));
      this.bundleProductChanged(_.cloneDeep(tempProduct));
    }
    if (
      this.bundleProduct &&
      this.bundleProduct.quantity === 1 &&
      (!this.bundleProduct.enable_quantity_step ||
        !this.bundleProduct.quantity_step)
    ) {
      //TODO GO TO ZERO???
      tempProduct.quantity = 0;
      tempProduct = this.checkProductQuantityToChoice(_.cloneDeep(tempProduct));
      this.bundleProductChanged(_.cloneDeep(tempProduct));
    }
  }

  productQuantityIncrease() {
    let tempProduct = _.cloneDeep(this.bundleProduct);

    if (
      this.bundleProduct.enable_quantity_step &&
      this.bundleProduct.quantity_step &&
      ((!this.bundleProduct.max_quantity &&
        parseFloat(
          parseFloat(
            _.cloneDeep(
              tempProduct.quantity + tempProduct.quantity_step
            ).toString()
          ).toFixed(QUANTITY_DECIMALS)
        ) < 50) ||
        this.noMaxStep)
    ) {
      tempProduct.quantity = parseFloat(
        parseFloat(
          _.cloneDeep(
            tempProduct.quantity + tempProduct.quantity_step
          ).toString()
        ).toFixed(QUANTITY_DECIMALS)
      );
    } else if (
      this.bundleProduct.enable_quantity_step &&
      this.bundleProduct.quantity_step &&
      this.bundleProduct.max_quantity &&
      parseFloat(
        parseFloat(
          _.cloneDeep(
            tempProduct.quantity + tempProduct.quantity_step
          ).toString()
        ).toFixed(QUANTITY_DECIMALS)
      ) < this.bundleProduct.max_quantity
    ) {
      tempProduct.quantity = parseFloat(
        parseFloat(
          _.cloneDeep(
            tempProduct.quantity + tempProduct.quantity_step
          ).toString()
        ).toFixed(QUANTITY_DECIMALS)
      );
    } else if (
      !this.bundleProduct.enable_quantity_step ||
      !this.bundleProduct.quantity_step
    ) {
      tempProduct.quantity++;
    }

    tempProduct = this.checkProductQuantityToChoice(_.cloneDeep(tempProduct));
    //console.log(tempProduct.quantity);
    //console.log("set selectedProduct");
    this.bundleProductChanged(_.cloneDeep(tempProduct));
  }

  changeSelectedProductQuantity(ev) {
    if (ev === "increase") {
      this.productQuantityIncrease();
    } else if (ev === "decrease") {
      this.productQuantityDecrease();
    }
  }

  hideBundleEditControl() {
    return !!(
      this.bundleProduct &&
      this.choice &&
      this.option &&
      this.option.bundle_options &&
      this.option.bundle_options.preselectedQuantityZero &&
      this.option.choices &&
      this.option.choices.length === 1 &&
      this.choice.bundle_options &&
      this.choice.bundle_options.enable_bundle_product_quantity
    );
  }

  onBundleProductImageClick(bundleChoice, product, event?) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (
      this.bundleEditOnImageEnabled &&
      this.image &&
      this.image.path &&
      !this.finalPriceLoading &&
      !this.hideBundleEditControl()
    ) {
      this.showProductDetailsModal(bundleChoice, product);
    }
  }

  showProductDetailsModal(bundleChoice, product) {
    let detailsCssClass;

    detailsCssClass = "productDetailsModal";

    console.log("detals css", detailsCssClass, product);
    if (!this.productDetailsModal) {
      this.productDetailsModal = true;
      this.store
        .select(
          selectors.getSelectedProductBySelectedProductId(
            this.selectedProductId
          )
        )
        .pipe(first())
        .subscribe((parentProduct) => {
          this.presentProductDetailsModal(
            _.cloneDeep(parentProduct),
            bundleChoice,
            product,
            detailsCssClass
          );
        })
        .unsubscribe();
    }
  }

  async presentProductDetailsModal(
    parentProduct,
    bundleChoice,
    product,
    cssClass
  ) {
    let product_id: string;
    let cart_id: string;
    if (product && product.product_id) {
      product_id = product.product_id;
    }

    if (product && product.cart_id) {
      cart_id = product.cart_id;
    }

    this.productDetailsModal = await this.modalController.create({
      component: ProductDetailsComponent,
      cssClass: cssClass,
      animated: true,
      componentProps: {
        bundleMode: "edit",
        product_id: product.product_id,
        bundleOptions: this.choice.bundle_options,
        parentProduct: parentProduct,
        parentBundleChoice: bundleChoice,
        edited_bundle_product: product,
        cart_id: null,
      },
      backdropDismiss: false,
    });

    await this.productDetailsModal.present();
    this.productDetailsModal.onDidDismiss().then((data) => {
      this.productDetailsModal = null;
      if (data && data.data && data.data.product) {
        let bundleProduct = _.cloneDeep(data.data.product);
        let selectedProduct = _.cloneDeep(this.selectedProduct);
        bundleProduct.productTotal = _.cloneDeep(data.data.price);
        if (
          bundleProduct.quantity === 0 &&
          !bundleProduct.disable_qty &&
          this.choice?.bundle_options?.enable_bundle_product_quantity
        ) {
          bundleProduct.productTotal = 0;
        }

        const optIndex = _.findIndex(selectedProduct.options, {
          option_id: this.option_id,
        });
        console.log("bundle product item opt index", optIndex);
        if (optIndex !== -1) {
          //for radio choices
          const chIndex = _.findIndex(
            selectedProduct.options[optIndex].choices,
            {
              is_preselected: true,
            }
          );
          console.log("bundle product item ch index", chIndex);
          if (
            chIndex !== -1 &&
            selectedProduct.options[optIndex] &&
            selectedProduct.options[optIndex].choices[chIndex] &&
            selectedProduct.options[optIndex].choices[chIndex]
              .bundled_product &&
            selectedProduct.options[optIndex].choices[chIndex].bundled_product
              .product_id === product.product_id
          ) {
            selectedProduct.options[optIndex].choices[chIndex].bundled_product =
              _.cloneDeep(bundleProduct);
          }
        }
        this.bundleProduct = _.cloneDeep(bundleProduct);

        console.log(
          "set selectedProduct from bundle product item",
          selectedProduct
        );
        if (optIndex !== -1) {
          this.optionChanged.emit(
            _.cloneDeep(selectedProduct.options[optIndex])
          );
        }
      }

      this.productDetailsModal = null;
    });
  }

  productHaveDetails(prd) {
    let showProducts = false;

    _.each(prd.options, (option) => {
      if (
        option &&
        option.option_id &&
        (!option.dependenciesVariable ||
          option.dependenciesVariable.length === 0 ||
          (option.dependenciesVariable.length > 0 && option.showDependent))
      ) {
        if (option.type !== "field") {
          if (
            !(
              option.choices &&
              !option.reverseChoices &&
              this.choicesIsPreselected(option.choices).length === 0
            ) ||
            (option.is_require && option.availableTotal)
          ) {
            if (
              !option.doNotPrint ||
              (option.parent_free && option.option_parent_total_price === 0)
            ) {
              //console.log("retuntrue");
              showProducts = true;
            } else {
              //console.log("retunfalse");
            }
          }
          if (
            option.type === "checkbox" &&
            option.reverseChoices &&
            option.choicesComment
          ) {
            //console.log("retuntrue");
            showProducts = true;
          }
          _.each(option.choices, (choice) => {
            if (
              !choice.doNotPrint &&
              (option.type !== "checkbox" ||
                !option.reverseChoices ||
                (!option.choicesComment && !option.reverseChoices))
            ) {
              showProducts = true;
            }

            if (choice.choicePriceComment) {
              showProducts = true;
            } else {
              if (choice.price) {
                showProducts = true;
              }
            }
          });
        } else {
          if (option.text) {
            //console.log("retuntrue");
            showProducts = true;
          } else {
            // console.log("retunfalse");
          }
        }
      } else {
        // console.log("retunfalse");
      }
    });
    return showProducts;
  }

  choicesIsPreselected(choices) {
    let preselectedArray = [];
    choices.forEach((choice) => {
      if (choice && choice.is_preselected) {
        preselectedArray.push(choice);
      }
    });

    return preselectedArray;
  }

  bundleProductChanged(bundled_product) {
    let selectedProduct = _.cloneDeep(this.selectedProduct);

    const optionIndex = _.findIndex(selectedProduct.options, {
      option_id: this.option_id,
    });

    if (optionIndex !== -1) {
      const choiceIndex = _.findIndex(
        selectedProduct.options[optionIndex].choices,
        { choice_id: this.choice.choice_id }
      );
      console.log("choic index", choiceIndex);
      if (choiceIndex !== -1) {
        this.store
          .select("deliveryMethodAddress")
          .pipe(first())
          .subscribe((deliveryMethodAddressState) => {
            this.store
              .select(selectors.getStoreInfo)
              .pipe(first())
              .subscribe((store_info) => {
                bundled_product =
                  this.productDetailsOperationsService.cartProductPrice(
                    _.cloneDeep(bundled_product),
                    this.orderPickup,
                    this.dineIn,
                    this.choice,
                    true,
                    store_info && store_info.dinein
                      ? store_info.alt_dinein_active
                      : false,
                    deliveryMethodAddressState.selectedDineInTable,
                    store_info.decimalPlacesPrices
                  );

                if (bundled_product.quantity === 0) {
                  bundled_product.productTotal = 0;
                }
                selectedProduct.options[optionIndex].choices[
                  choiceIndex
                ].bundled_product = bundled_product;
                // selectedProduct.options[optionIndex].choices[
                //   choiceIndex
                // ].is_preselected = false;

                console.log("set selectedProduct");
                if (optionIndex !== -1) {
                  this.optionChanged.emit(
                    _.cloneDeep(selectedProduct.options[optionIndex])
                  );
                }
              })
              .unsubscribe();
          })
          .unsubscribe();
      }
    }
  }

  deleteBundleProduct(bundled_product) {
    let selectedProduct = _.cloneDeep(this.selectedProduct);
    const optionIndex = _.findIndex(selectedProduct.options, {
      option_id: this.option_id,
    });
    // console.log(
    //   "optio index",
    //   selectedProduct,
    //   optionIndex,
    //   selectedProduct.options[optionIndex],
    //   this.choice.choice_id
    // );
    if (optionIndex !== -1) {
      const choiceIndex = _.findIndex(
        selectedProduct.options[optionIndex].choices,
        { choice_id: this.choice.choice_id }
      );
      console.log("choic index", choiceIndex);
      if (choiceIndex !== -1) {
        selectedProduct.options[optionIndex].choices[
          choiceIndex
        ].bundled_product = null;
        selectedProduct.options[optionIndex].choices[
          choiceIndex
        ].is_preselected = false;
        console.log("set selectedProduct");
        if (optionIndex !== -1) {
          this.optionChanged.emit(
            _.cloneDeep(selectedProduct.options[optionIndex])
          );
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.productValidDeliveryAreasModal) {
      this.productValidDeliveryAreasModal.dismiss();
      this.productValidDeliveryAreasModal = null;
    }

    if (this.productDetailsModal) {
      this.productDetailsModal.dismiss();
      this.productDetailsModal = null;
    }
    if (this.subscriptions && this.subscriptions.length) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });

      this.subscriptions = [];
    }
  }
}
